import { Layout } from 'antd';
import styled, { css } from 'styled-components';

type ContentProps = {
  $isMobileVersion: boolean;
  $sidebarWidth?: number;
};

export const ContentStyled = styled(Layout.Content)<ContentProps>`
  background-color: var(--white);
  font-family: 'Inter', sans-serif;
  color: var(--gray-200);
  transition: margin-left 0.3s ease-in-out;

  ${({ $isMobileVersion, $sidebarWidth }) =>
    $isMobileVersion
      ? css`
          min-height: calc(100vh - 64px);
          padding: 20px 15px 0;
          margin-left: 0;
        `
      : css`
          min-height: 100vh;
          padding: 20px 24px 0;
          margin-left: ${$sidebarWidth || 256}px;
        `}
`;
